import type { MDXComponents } from 'mdx/types'
import { Divider } from '@heroui/react'

export function useMDXComponents(components: MDXComponents): MDXComponents {
  return {
    h1: ({ children, ...props }) => (
      <h1 className="text-xl font-semibold" {...props}>
        {children}
      </h1>
    ),
    h2: ({ children, ...props }) => (
      <h2 className="text-lg font-semibold" {...props}>
        {children}
      </h2>
    ),
    p: ({ children, ...props }) => (
      <p className="text-sm mt-2 mb-2" {...props}>
        {children}
      </p>
    ),
    hr: () => (
      <Divider className="mt-4 mb-4" />
    ),
    ul: ({ children, ...props }) => (
      <ul className="list-disc list-inside my-6" {...props}>
        {children}
      </ul>
    ),
    li: ({ children, ...props }) => (
      <li className="mt-2 mb-2 ml-4 text-sm" {...props}>
        {children}
      </li>
    ),
    code: ({ children, ...props }) => (
      <code className="bg-neutral-600 p-1 rounded-md text-amber-500" {...props}>
        {children}
      </code>
    ),
    pre: ({ children, ...props }) => (
      <pre className="bg-neutral-800 p-4 rounded-md text-xs my-4 [&>code]:bg-neutral-800 [&>code]:text-amber-200" {...props}>
        {children}
      </pre>
    ),

    ...components,
  }
}
